import SRTooltip, { type TooltipProps } from '@semcore/ui/tooltip';

import { useTheme } from '@/features/theme-switch';

export default function Tooltip({
  children,
  className,
  withTheme,
  ...props
}: TooltipProps & { className?: string; withTheme?: boolean }) {
  const { darkTheme } = useTheme();
  const withDarkTheme = darkTheme ? 'invert' : 'default';

  return (
    <SRTooltip theme={withTheme ? withDarkTheme : 'invert'} {...props}>
      <span className={className || 'cursor-help'}>{children}</span>
    </SRTooltip>
  );
}
